export default "__VITE_ASSET__vqHubTlf__"